import { Outlet } from 'react-router';

import authBg from '@/assets/images/auth-bg.jpg';

const AuthLayout = () => {
  return (
    <main
      className="flex items-center justify-center flex-1 min-h-screen bg-cover bg-center bg-no-repeat"
      style={{ backgroundImage: `url(${authBg})` }}
    >
      <Outlet />
    </main>
  );
};

export default AuthLayout;
